import {ApplicationState} from '../../redux/state';
import { connect } from 'react-redux';
import { updateInputData } from '../../redux/product/productActions';
import {  Dispatch } from "redux";
import ClampingElement from './ClampingElement';

const mapStateToProps = ({product}: ApplicationState) => {
    return {
        shaftDiameter_d: product.productInputData.shaftDiameter_d,
        hubInnerDiameter_D: product.productInputData.hubInnerDiameter_D,
        screwBoltingTorque_Ts: product.productInputData.screwBoltingTorque_Ts,
        screwBoltingTorque_Ts_db: product.currentProduct.screwBoltingTorque_Ts,
        screwBoltingTorqueOverwritePercentage: product.productInputData.screwBoltingTorqueOverwritePercentage,
        currentClampexType: product.currentProduct.type,
        clampingForce_PA:product.currentProduct.clampingForce_PA,
        clampingForce_PO: product.currentProduct.clampingForce_PO,
        clampexSizes: product.currentProduct.sizes,
        errorFields: product.productInputData.errorFields,
        dimensions_Ds: product.currentProduct.dimension_Ds,
        dimensions_B1: product.currentProduct.dimension_B1,
        dimensions_B2: product.currentProduct.dimension_B2,
        dimensions_B3: product.currentProduct.dimension_B3,
        dimensions_B: product.currentProduct.dimension_B,
        dimensions_D1: product.currentProduct.dimension_D1,
        cat_AxialForce_T: product.currentProduct.cat_AxialForce_T,
        cat_AxialForce_FAX: product.currentProduct.cat_AxialForce_fax,
        cat_SurfacePressureHub_PN: product.currentProduct.cat_SurfacePressureHub_PN,
        cat_SurfacePressureShaft_PW: product.currentProduct.cat_SurfacePressureShaft_PW,
        screwsize: product.currentProduct.screwSize,
        type: product.currentProduct.type,
        screwLength_mm: product.currentProduct.screwLength_mm,
        screwNumber: product.currentProduct.screwNumber,
        weigth_kg: product.currentProduct.weight_kg,
        screwPreloadForce_Fv: product.currentProduct.screwPreloadForce_Fv
    };
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    inputChanged:(productInputData: any) => dispatch(updateInputData(productInputData))
});

const ConnectedClampingElement = connect(
    mapStateToProps,
    mapDispatchToProps
)(ClampingElement)

export default ConnectedClampingElement;